<template>
  <v-card class="rounded-card" :color="color">
    <v-layout px-1 py-2>
      <slot></slot>
    </v-layout>
  </v-card>
</template>

<script>
export default {
  name: "simple_card",
  props: {
    color: {
      type: String,
      default: "white"
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.rounded-card {
  border-radius: 4px;
}
</style>
